import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { TemplateApiService } from '../services/template-api.service';
import { BuilderScreenBetaService } from '../services/builder-screen.service';
import { TabControlService } from '../services/tab-control.service';
import { SaveComponentsService } from '../services/save-components.service';
import { DataBindingService } from '../../screen-engine/services/data-binding.service';
import { DataSyncService } from '../../screen-engine/services/data-sync.service';
import { FormSyncService } from '../services/form-sync.service';
import { DataPathService } from '../services/data-path.service';
import { RxTimingService } from '../../screen-engine/services/rx-timing.service';
import { FlowCompletionNotifyService } from '../services/flow-completion-notify.service';
import { Subscription } from 'rxjs';
import { LEGACY_RENDERERS_PROVIDER } from '../bridge/engine-renderers';

export interface TemplateDetailContext {
  evento?: string;
  row?: any;
  formGroup?: any;
  parentRow?: any;
  entityName?: string;
  tableInformation?: any;
  [key: string]: any;
}

@Component({
  selector: 'app-template-detail',
  templateUrl: './template-detail.component.html',
  styleUrls: ['./template-detail.component.scss'],
  standalone: false,
  providers: [
    BuilderScreenBetaService,
    TabControlService,
    SaveComponentsService,
    DataBindingService,
    DataSyncService,
    FormSyncService,
    DataPathService,
    RxTimingService,
    FlowCompletionNotifyService,
    // O `datagrid` do motor novo e desenhado pelo componente antigo, emprestado
    // pelo lado legado. Ver bridge/engine-renderers.ts.
    LEGACY_RENDERERS_PROVIDER
  ]
})
export class TemplateDetailComponent implements OnInit, OnDestroy {
  @Input() templateId: number;
  /**
   * Contexto vindo do `simple-datagrid`: a linha, a linha do pai, a entidade.
   *
   * ACHADO: no caminho ANTIGO este input nao e lido em lugar nenhum. O
   * `simple-datagrid` o preenche (linha 2254) e o valor morre aqui. Como a
   * propriedade de la se chama `templateIdForAdd`, formulario vazio e o
   * esperado na inclusao — mas `parentRow` e `entityName`, que a tela precisaria
   * para gravar no lugar certo, tambem se perdem.
   *
   * No caminho NOVO o contexto e entregue ao motor, que preenche os campos cujo
   * `dataPath` casar. Nao mexo no caminho antigo: mudar comportamento de fluxo
   * de producao nao e efeito colateral de uma migracao.
   */
  @Input() context: TemplateDetailContext = {};
  @Output() saving = new EventEmitter<{ changing: boolean; keepOpen: boolean }>();

  loading = true;
  error = false;
  errorMessage = '';
  private flowCompleteSub?: Subscription;

  constructor(
    private flowCompletionNotify: FlowCompletionNotifyService
  ) {}

  ngOnInit(): void {
    if (!this.templateId || this.templateId <= 0) {
      this.error = true;
      this.errorMessage = 'Template ID não fornecido ou inválido';
      this.loading = false;
      return;
    }

    this.flowCompleteSub = this.flowCompletionNotify.onFlowComplete$.subscribe(() => {
      this.saving.emit({ changing: true, keepOpen: false });
    });

    // O motor carrega sozinho, pela porta unica (`ScreenDocumentApiService`).
    // Nao ha `applyTemplate` nem servico global no meio: o `<tem-screen-view>`
    // le, monta o formulario e desenha.
    this.loading = false;
  }

  ngOnDestroy(): void {
    this.flowCompleteSub?.unsubscribe();
  }

}
